import { render } from "./BotManager.vue?vue&type=template&id=417e08de&scoped=true"
import script from "./BotManager.vue?vue&type=script&lang=js"
export * from "./BotManager.vue?vue&type=script&lang=js"

import "./BotManager.vue?vue&type=style&index=0&id=417e08de&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417e08de"]])

export default __exports__